







































































































































































































import Vue from 'vue';
import VatsAPI from '@/Shared/VatsAPI';
import {UserProfile} from './UserProfile';
import {LoginRole} from './LoginRole';
import {UserDatabase} from './UserDatabase';
import {Location} from '@/Stores/UserStore';
import {getValidationErrors} from '@/Shared/ValidationErrorDirective';
import Multiselect from 'vue-multiselect';
import RadioToggle from '@/Shared/RadioToggle.vue';

const UserManagementAdmin = Vue.extend({
    async beforeMount() {
        const locations: Location[] = await this.$typedStore.modules.userModule.actions.getAllowedLocations();
        this.allowedLocations = locations.slice().sort((a, b) => a.companyName.localeCompare(b.companyName));
        this.selectedLocation = this.allowedLocations
            .find(item => item.urlSegment.toUpperCase() === this.location.toUpperCase())
            || null;
        if (this.selectedLocation) {
            this.selectedLocationId = this.selectedLocation.locationId;
        }
    },
    props: ['location'],
    components: {
        Multiselect,
        RadioToggle
    },
    data() {
        return {
            loadMeOnly: false,
            editUser: { isAddUser: false } as any as UserProfile,
            addUser: { isAddUser: true } as any as UserProfile,
            userProfiles: [] as UserProfile[],
            loginRoles: [] as LoginRole[],
            selectedRole: null,
            loadingUsers: {} as { [userID: string]: boolean },
            validationErrors: {} as { [key: string]: string[] },
            selectedLocationId: null as number | null,
            selectedLocation: null as Location | null,
            selectedLocationDBName: '',
            selectedLocations: [],
            allowedLocations: [] as Location[]
        };
    },
    computed: {
        userDatabaseOptions(): UserDatabase[] {
            return this.allowedLocations.map(al => {
                const userDatabase = {} as UserDatabase;
                userDatabase.userID = this.editUser.userID;
                userDatabase.databaseName = al.databaseName;
                return userDatabase;
            });
        },
        currentRole(): (roleId: number) => string {
            return (roleId: number) => {
                const role = this.loginRoles.find(item => item.recID === roleId);
                if (role) {
                    return role.description;
                }
                return '';
            };
        }
    },
    methods: {
        editing(user: UserProfile) {
            if ((user as any).isAddUser) {
                return true;
            }
            else if (this.editUser && this.editUser.userID && !(this.editUser as any).isAddUser) {
                return this.editUser.userID === user.userID;
            }
            else {
                return false;
            }
        },
        edit(user: UserProfile) {
            this.editUser = { ...user };

            if (!this.editUser.paymentAcceptance) {
                this.editUser.paymentAcceptance = false;
            }
            if (!this.editUser.mustResetPassword) {
                this.editUser.mustResetPassword = false;
            }
            if (!this.editUser.locked) {
                this.editUser.locked = false;
            }
        },
        add() {
            this.editUser = { ...this.addUser };

            if (!this.editUser.paymentAcceptance) {
                this.editUser.paymentAcceptance = false;
            }
            if (!this.editUser.mustResetPassword) {
                this.editUser.mustResetPassword = false;
            }
            if (!this.editUser.locked) {
                this.editUser.locked = false;
            }
        },
        async save(user: UserProfile) {
            Vue.set(this.loadingUsers, user.userID, true);

            let isAddUser: boolean = false;

            try {
                isAddUser = (user as any).isAddUser;

                if (isAddUser) {
                    await VatsAPI.post(`/UserManagementAdmin/AddUserProfile`, user);
                }
                else {
                    this.selectedLocationDBName = this.editUser.userDatabase;
                    await VatsAPI.post(`/UserManagementAdmin/UpdateUserProfile`, user);
                }

                await this.refreshUsers();
            }
            catch (e) {
                this.validationErrors = getValidationErrors(e.response);

                const title = this.$i18n.t('common.error').toString();
                let message: string;

                if (this.validationErrors.hasOwnProperty('Password')) {
                  message = this.validationErrors[`Password`][0];
                }
                else {
                  message = isAddUser
                      ? this.$i18n.t('admin.userManagement.addUserError').toString()
                      : this.$i18n.t('admin.userManagement.editUserError').toString();
                }

                this.$bvToast.toast(message, {title, autoHideDelay: 5000});

                throw e;
            }
            finally {
                Vue.set(this.loadingUsers, user.userID, false);
            }

            this.cancelEdit();
        },
        async deleteUser(user: UserProfile) {
            const deleteConfirmMessage = this.$i18n.t('admin.userManagement.deleteConfirmMessage').toString() + `, ${user.userID}?`;
            const deleteConfirmTitle = this.$i18n.t('admin.userManagement.deleteConfirmTitle').toString();
            const deleteButton = this.$i18n.t('common.delete').toString();
            const cancelButton = this.$i18n.t('common.cancel').toString();

            const confirmDelete = await this.$bvModal.msgBoxConfirm(
                deleteConfirmMessage,
                {
                    title: deleteConfirmTitle,
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    cancelVariant: 'info',
                    okTitle: deleteButton,
                    cancelTitle: cancelButton,
                    centered: true
                }
            );

            if (confirmDelete) {
                try {
                    Vue.set(this.loadingUsers, user.userID, true);
                    await VatsAPI.post(`/UserManagementAdmin/DeleteUserProfile`, user);
                    await this.refreshUsers();
                    Vue.set(this.loadingUsers, user.userID, false);
                }
                catch (e) {
                    this.$bvToast.toast(this.$i18n.t('admin.userManagement.deleteUserError').toString(), {
                        title: this.$i18n.t('common.error').toString(),
                        autoHideDelay: 5000
                    });
                    throw e;
                }
            }
        },
        cancelEdit() {
            this.editUser = { isAddUser: false } as any as UserProfile;
            this.addUser = { isAddUser: true } as any as UserProfile;
        },
        async refreshUsers() {
            try {
                if (this.loadMeOnly) {
                    this.userProfiles = (await VatsAPI.get<UserProfile[]>(`/UserManagementAdmin/GetMeOnly`)).data;
                }
                else {
                    this.userProfiles = (await VatsAPI.get<UserProfile[]>(`/UserManagementAdmin/GetUserProfiles`)).data;
                }
            }
            catch (e) {
                this.$bvToast.toast(this.$i18n.t('admin.userManagement.refreshUserError').toString(), {
                    title: this.$i18n.t('common.error').toString(),
                    autoHideDelay: 5000
                });
                throw e;
            }
        },
        async getMeOnly() {
            try {
                this.refreshUsers();
            }
            catch (e) {
                this.$bvToast.toast(this.$i18n.t('admin.userManagement.refreshUserError').toString(), {
                    title: this.$i18n.t('common.error').toString(),
                    autoHideDelay: 5000
                });
                throw e;
            }
        },
        getDatabaseNames(userDatabases: UserDatabase[]) {
            return userDatabases.map(d => d.databaseName).join(', ');
        }
    },
    async mounted() {
        this.loginRoles = (await VatsAPI.get<any[]>('/UserManagementAdmin/GetUserRoles')).data;
        this.refreshUsers();
    }
});

export default UserManagementAdmin;
